module.exports = __webpack_public_path__ + "img/banner_vivobook_go.3e833e26.jpg";